import React from 'react'
import _ from 'underscore'
import { ErrorAnnotations } from '../../domain/Error'

interface Props {
    annotations: ErrorAnnotations
}

export class Context extends React.Component<Props> {
    public render() {
        return (
            <table className="table table-striped">
                <tbody>
                    {_.map(this.props.annotations, (value, key) => (
                        <tr key={key}>
                            <th>{key}</th>
                            <td>{value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )
    }
}

export default Context
